import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function stripQueryParams(url: string): string {
  try {
    const parsedUrl = new URL(url);
    parsedUrl.search = ""; // remove query string
    return parsedUrl.toString();
  } catch (err) {
    console.error("Invalid URL:", url, err);
    return url; // fallback to original if parsing fails
  }
}
// Helper function to extract filename from path
export const extractFilename = (path: string | undefined) => {
  if (!path) return 'Unknown file';
  return path.split('/').pop() || path;
};

export const validateName = (value: string) => {
  if (!value.trim()) {
    return "Group name cannot be empty.";
  }
  if (!/^[a-zA-Z0-9 _']+$/.test(value)) {
    return "Only letters, numbers, spaces, underscores (_), and apostrophes (') are allowed.";
  }
  return "";
};

export const normalize = (task: string) =>
  task === 'ProductInfoDataGeneration'
    ? 'RawFeedProductInfoGeneration'
    : task;
